import { Injectable, signal } from '@angular/core';
import { BaseService } from './base.service';
import {
  Banner,
  IResponse,
  Page,
  PageQuery,
  UserNotification,
} from '@models/common.model';
import { EndPoint } from '@constants/api.constant';
import { Bank } from '@models/users.model';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService extends BaseService {
  private _loading = signal(false);

  get loading() {
    return this._loading.asReadonly();
  }

  showLoading() {
    this._loading.set(true);
  }

  hideLoading() {
    this._loading.set(false);
  }

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    let url = EndPoint['uploadFile'].path;
    if (file.type.includes('image')) {
      url = EndPoint['botImageUpdate'].path;
    }
    return this.http
      .post<IResponse<string>>(url, formData)
      .pipe(
        catchError(() =>
          this.http.post<IResponse<string>>(
            EndPoint['uploadFile'].path,
            formData
          )
        )
      );
  }

  getBanks() {
    return this.http.get<IResponse<Page<Bank>>>(EndPoint['bank'].path, {
      params: {
        page: 1,
        size: 40000,
      },
    });
  }

  searchNotification(params: PageQuery) {
    return this.http.get<
      IResponse<Page<UserNotification> & { unread: number }>
    >(EndPoint['notification'].path, {
      params,
    });
  }

  readNotification(notiId: number) {
    return this.http.put(
      `${EndPoint['readNotification'].path}`,
      {},
      {
        params: { notiId },
      }
    );
  }

  readAllNotification() {
    return this.http.put(`${EndPoint['readAllNotification'].path}`, {});
  }

  getBanners() {
    return this.http.get<IResponse<Banner[]>>(EndPoint['banners'].path, {
      params: { contentType: 'BANNER' },
    });
  }
}
